import axios from "axios";

// ✅ Comunicação direta com Render
const api = axios.create({
  baseURL: "https://files-site-bd2025.onrender.com",
});

export const buscarPorCpf = async (cpf: string) => {
  const response = await api.get(`/cpf/${cpf}`);
  return response.data;
};

export default api;
